module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    attrs: {
      "id": "nutrition-input"
    }
  }, [_c('mu-card-text', {
    staticClass: "card-style",
    class: {
      cardHasData: _vm.hasData
    }
  }, [(_vm.loading) ? _c('div', [_c('mu-flexbox', {
    staticClass: "card-loading-padding",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 56,
      "color": "#FFFFFF",
      "strokeWidth": 5
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "animated fadeIn pointer",
    on: {
      "click": _vm.goToDetail
    }
  }, [(!_vm.hasData) ? _c('mu-flexbox', {
    staticClass: "card-error-padding",
    attrs: {
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "card-notice-title"
  }, [_vm._v(_vm._s(_vm.$t('message.cardNutritionEmpty')))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.cardTapPrefix')) + "\n            "), _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "add"
    },
    slot: "left"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('message.cardNutritionSubLine')))])], 1)])], 1) : _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.goToDetail
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v(_vm._s(_vm.hasData = true))]), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v(_vm._s(_vm.$t('message.nutrientCarbohydrate')))]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "card-large-stat"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.data.total_carbohydrate + 'g')
    }
  })])])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v(_vm._s(_vm.$t('message.nutrientProtein')))]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.data.total_protein + 'g')
    }
  })])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v(_vm._s(_vm.$t('message.nutrientFat')))]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.data.total_fat + 'g')
    }
  })])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v(_vm._s(_vm.$t('message.nutrientCalories')))]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.data.total_calories + 'kcal')
    }
  })])], 1)], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('mu-card-actions', [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('svg', {
    staticClass: "card-left-icon",
    attrs: {
      "width": "16px",
      "height": "16px",
      "viewBox": "26 191 14 17",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Group-4",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(26.000000, 191.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7.66316596,4.72800156 C7.06563404,4.87701832 6.44003404,4.87701832 5.84250213,4.72800156 C2.73012766,3.95229786 0.12413617,4.24974815 0.154229787,10.1646347 C0.169565957,13.194545 2.98505532,17.1232218 5.94406809,16.4510425 C6.47475745,16.3306043 7.03062128,16.3306043 7.56131064,16.4510425 C10.5203234,17.1232218 13.3358128,13.194545 13.3511489,10.1646347 C13.3812426,4.25003977 10.7755404,3.95229786 7.66316596,4.72800156 L7.66316596,4.72800156 Z",
      "id": "Shape",
      "fill": "#89C93B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1.6010383,8.65347057 C1.44102128,8.65347057 1.3116766,8.52282573 1.3116766,8.36185263 C1.3116766,6.75387135 2.47982979,5.44567329 3.91593191,5.44567329 C4.07594894,5.44567329 4.20529362,5.57631813 4.20529362,5.73729123 C4.20529362,5.89826433 4.07594894,6.02890916 3.91593191,6.02890916 C2.79928511,6.02890916 1.8904,7.07552593 1.8904,8.36185263 C1.8904,8.52282573 1.76076596,8.65347057 1.6010383,8.65347057 L1.6010383,8.65347057 Z",
      "id": "Shape",
      "fill": "#89C93B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6.732,5.83206706 C6.57661277,5.83206706 6.44813617,5.7075462 6.44321702,5.5497809 C6.40415319,4.3156538 5.93365106,2.76628772 4.72961702,2.11918752 C4.58869787,2.04336686 4.53516596,1.86693801 4.6104,1.72462846 C4.6859234,1.58261053 4.86040851,1.52866121 5.00219574,1.60448187 C6.42411915,2.36852086 6.97766809,4.13368421 7.02165106,5.53111735 C7.02685957,5.69209045 6.90156596,5.82681793 6.74154894,5.83177544 C6.7380766,5.83206706 6.73518298,5.83206706 6.732,5.83206706 L6.732,5.83206706 Z",
      "id": "Shape",
      "fill": "#89C93B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6.70624681,6.87985029 C6.22011915,6.87985029 5.7626383,6.68884055 5.41858723,6.3418152 C5.30544681,6.22808421 5.30544681,6.04349006 5.41858723,5.92946745 C5.53172766,5.81544483 5.71460426,5.81544483 5.82774468,5.92946745 C6.06270638,6.16626121 6.37492766,6.29661442 6.70624681,6.29661442 C7.03756596,6.29661442 7.34978723,6.16626121 7.58445957,5.92946745 C7.6976,5.81544483 7.8804766,5.81544483 7.99361702,5.92946745 C8.10675745,6.04319844 8.10675745,6.22779259 7.99361702,6.3418152 C7.64956596,6.68884055 7.19237447,6.87985029 6.70624681,6.87985029 L6.70624681,6.87985029 Z",
      "id": "Shape",
      "fill": "#89C93B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6.45421277,3.80269786 L6.63043404,2.61114698 C6.81649362,1.35281559 7.79685106,0.364814035 9.04544681,0.177303704 L10.2274894,0 L10.0512681,1.19155088 C9.86520851,2.44988226 8.88485106,3.43788382 7.63625532,3.62539415 L6.45421277,3.80269786 L6.45421277,3.80269786 Z",
      "id": "Shape",
      "fill": "#89C93B"
    }
  })])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.loading ? _vm.$t('message.loadingText') : _vm.title)
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": 'add'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToDetail.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32506c26","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/Input/Nutrition/Nutrition.vue
// module id = 3113
// module chunks = 1